module.exports = __webpack_public_path__ + "img/roleAdmin.3fac6900.svg";